<template>
  <div class="dialogcontainer">

      <div class="CloseButton" @click="closeUpdate"></div>


    <div id="AcronymsHeader">


        <div class="unlockTitle">Unlock Content</div>

      <div class="unlockSummary">Enter your email below to be sent an access code. </div>
       <div class="confirmed" v-show="success" style="margin-top: 15px;">A code has been sent to your email address </div>
    </div>
    <div class="content">
      <input class="unlockInput" v-model="email" name="email" placeholder="email">
      <button class="unlockBtn" v-on:click="requestCode()">request code</button>
      <div class="unlockSummary" style="margin-top: 15px;">Once you receive a code enter it below for access.</div>
      <input class="unlockInput" v-model="code"  name="code" placeholder="code">
      <button class="unlockBtn" v-on:click="requestToken()">Unlock</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "UnlockComponent",

  data () {
    return {
      code: '',
      email:'',
      success:false
    }
  },
mounted() {
},
  methods: {

    closeUpdate () {
      this.$emit('acronymsState', false)
      this.$emit('close')
    },
    requestCode(){
      axios.post(process.env.VUE_APP_API_URL+'/wl-register', {
        email: this.email
      },{headers:{'Content-Type': 'application/json'}}).then((response)=>{

        if(response.data.status && response.data.status === "ok"){
          // sent email, ask them to check it.
          this.success = true;

        }
        else {
          //not found, ask them to register interest
          //emit close event with register dialog
          this.$emit("close", "register");
        }
      }).catch((error)=>{
        console.log("error", error)
      })
    },
    requestToken(){
      axios.post(process.env.VUE_APP_API_URL+'/wl-login', {
        email: this.email,
        code: this.code
      },{headers:{'Content-Type': 'application/json'}}).then((response)=>{

        if (response.data.token != null){
          //we got a token from API
          let d = new Date();
          d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();
         document.cookie =
              "usertoken=" + response.data.token + ";" + expires + ";path=/";
          document.cookie =
              "email=" + this.email;
          this.$emit('unlock');
        }
      }).catch((error)=>{
        console.log("error", error)
      })
    }
  },
}
</script>
<style scoped>
.dialogcontainer{
  padding: 25px;
}
.unlockTitle{
  color: #006DFF;
  font-size: 40px;
}
.content{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

}

.confirmed {
    color:green;
    font-weight:bold;
    font-size:18px;
    text-align:center;
}

.unlockInput{
  border-radius: 4px;
  background: #EFEFF4;
  border: 1px solid #8A8A8F;
  height: 50px;
  margin: 15px;
  width: 100%;
}
.unlockBtn{
  background: #006DFF;
  border-radius: 4px;
  color:white;
  height: 50px;
  border: 1px solid #006DFF;
  width: 100%;
}
.unlockSummary{
  color: #666666;
  font-size:18px;
}
.CloseButton{
  position: absolute;
  top:10px;
  right:10px;
}
</style>